import { OfficeTable } from "@/app/Offices/Components/OfficeTable";
import {
  DataTableColDef,
  DataTableColumnHeader,
} from "@/lib/Components/DataTable/DataTable";
import { SupplierOfficeListItem } from "@/app/Offices/GraphQL/supplierOfficeListQuery";
import { JucyOfficeCodeCell } from "@/app/Settings/Integrations/Jucy/Components/JucyOfficeCodeCell";
import { ModelLinkCell } from "@/lib/Components/DataTable/Cells/ModelLinkCell";

export function JucyOfficeTable() {
  const supplierOfficeCols: DataTableColDef<
    SupplierOfficeListItem,
    any,
    any
  >[] = [
    {
      id: "name",
      accessorFn: (data) => data.name,
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Name" />
      ),
      cell: ({ row }) => {
        return (
          <ModelLinkCell
            from="/$tenant/$orgId/supplier/{-$supplierId}"
            to={"/$tenant/$orgId/supplier/{-$supplierId}/offices/$id"}
            params={(prev) => ({ ...prev, id: row.original.id })}
            viewTransition
          >
            {row.original.name}
          </ModelLinkCell>
        );
      },
    },
    {
      id: "code",
      accessorFn: (data) => data.code ?? "--",
      header: ({ column }) => (
        <DataTableColumnHeader column={column} title="Code" />
      ),
    },
    {
      id: "jucy",
      header: "Jucy Site Code",
      cell: JucyOfficeCodeCell,
    },
  ];

  return (
    <OfficeTable
      id="settings-integrations-jucy-offices"
      columns={supplierOfficeCols}
    />
  );
}
